import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import HeadersList from './HeadersList';
import headersSet from './constants/headersSet';
import { FILTERS } from './constants';

/*
  Presentational component for Headers
*/

const Headers = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={headersSet}
    withoutSearch
  >
    <HeadersList />
  </Filterable>
);

Headers.displayName = 'HeadersPage';

export default Headers;



// WEBPACK FOOTER //
// ./src/containers/components/Header/Headers.js